export default "__VITE_ASSET__DZmLWUQu__"